module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"Bilgi Kütüphanesi","docColumn":"Doküman","uploadingDate":"Yüklenme Tarihi","operation":"İşlem","confirm":"Klasörü silmek istediğinize emin misiniz?"},"en":{"title":"Information Library","docColumn":"Document","uploadingDate":"Uploading Date","operation":"Operation","confirm":"Are you sure to delete this folder?"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Library/Library.vue
// module id = fIEE
// module chunks = 1